import apiClient from './axios';

/**
 * Businesses' own domains for their shops (www.theirbrand.com).
 *
 * Read-only apart from removal: a business connects and fixes its domain
 * itself, from the app. This is for support — "why isn't my domain
 * working?" — and for pulling a domain in an abuse case.
 */
export type StorefrontDomainStatus = 'pending' | 'active' | 'misconfigured';

export interface StorefrontDomainRow {
  id: string;
  vendorId: string;
  businessId: string;
  shopName: string | null;
  hostname: string;
  /** The bare domain that redirects to `hostname`, for a www pair. */
  apex: string | null;
  requested: string;
  status: StorefrontDomainStatus;
  lastFindings: {
    ownership: 'ok' | 'missing';
    host: 'ok' | 'missing' | 'elsewhere';
    apex: 'ok' | 'missing' | 'elsewhere' | null;
    hostSeen: string[];
    apexSeen: string[];
  } | null;
  lastError: string | null;
  lastCheckedAt: string | null;
  activatedAt: string | null;
  createdAt: string;
}

export const storefrontDomainsApi = {
  async list(): Promise<StorefrontDomainRow[]> {
    const res = await apiClient.get('/admin/storefront-domains');
    return res.data.data;
  },

  async remove(id: string): Promise<void> {
    await apiClient.delete(`/admin/storefront-domains/${id}`);
  },
};
